import { render, staticRenderFns } from "./SummaryByDoctor.vue?vue&type=template&id=19a0a93a"
import script from "./SummaryByDoctor.vue?vue&type=script&lang=js"
export * from "./SummaryByDoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports